import { BlogCategoryContent } from 'components/Blog/blogTypes';
import React, { FunctionComponent } from 'react';
import useStyles from './BlogTopCategories.css';
import { useRouter } from 'next/router';

interface BlogTopCategoriesSecondaryProps
{
  category: BlogCategoryContent;
}

export const BlogTopCategoriesSecondary: FunctionComponent<BlogTopCategoriesSecondaryProps> = (props) => {
  const classes= useStyles();
  const router = useRouter();
  const redirectToCategoryPage = (slug: string) => {
    if(slug) {
      router.push(`/blog/categories/${slug}`);
    }
  };

  return (<>
    <div
      onClick={() => redirectToCategoryPage(props.category?.slug || '')}
      key={props.category.slug} className={classes.categoriesItem}
    >
      <div  className={classes.categoriesImgContainer}>
        <img className={classes.imgContainer} src={props.category?.categoryCustomFields?.featuredImage?.sourceUrl || ''}/>
      </div>
      <div className={classes.categoriesDetailsContainer}>
        <div className={classes.categoriesDetailTiltle}>
          {props.category?.name}
        </div>
        <div className={classes.categoriesDetailSubtitleTiltle}>
          {props.category?.seo?.description}
        </div>
      </div>
    </div>
  </>);
};
